import Monitoring from "../monitoring/monitoring";
import GuiidePlusView from "./guiidePlusView";

class GuiidePlusMonitoring {
  private guiidePlusPrefix = "GPlus";

  public logView(guiidePlusView: GuiidePlusView) {
    Monitoring.gaEvent(this.getGuiidePlusViewMonitoringCode(guiidePlusView), 0);
  }

  public logMainJourney() {
    Monitoring.gaEvent(`${this.guiidePlusPrefix}MnJry`, 0);
  }

  public logLowCostProviders() {
    const providerCode = this.getGuiidePlusViewMonitoringCode(
      GuiidePlusView.Providers
    );
    Monitoring.gaEvent(`${providerCode}LwCst`, 0);
  }

  public logWellKnownBrandProvider() {
    const providerCode = this.getGuiidePlusViewMonitoringCode(
      GuiidePlusView.Providers
    );
    Monitoring.gaEvent(`${providerCode}WKBnd`, 0);
  }

  public logEcoFriendlyProviders() {
    const providerCode = this.getGuiidePlusViewMonitoringCode(
      GuiidePlusView.Providers
    );
    Monitoring.gaEvent(`${providerCode}EcoFr`, 0);
  }

  public logShariaProviders() {
    const providerCode = this.getGuiidePlusViewMonitoringCode(
      GuiidePlusView.Providers
    );
    Monitoring.gaEvent(`${providerCode}Shria`, 0);
  }

  public logGuaranteedIncomeModeller() {
    const giCode = this.getGuiidePlusViewMonitoringCode(
      GuiidePlusView.GuaranteedIncome
    );
    Monitoring.gaEvent(`${giCode}Modlr`, 0);
  }

  public logGuaranteedIncomeFixedPeriod() {
    const giCode = this.getGuiidePlusViewMonitoringCode(
      GuiidePlusView.GuaranteedIncome
    );
    Monitoring.gaEvent(`${giCode}FxPer`, 0);
  }

  public logGuaranteedIncomeAllIn() {
    const giCode = this.getGuiidePlusViewMonitoringCode(
      GuiidePlusView.GuaranteedIncome
    );
    Monitoring.gaEvent(`${giCode}AllIn`, 0);
  }

  private getGuiidePlusViewMonitoringCode(guiidePlusView: GuiidePlusView) {
    switch (guiidePlusView) {
      case GuiidePlusView.Dashboard:
        return `${this.guiidePlusPrefix}Dshbd`;
      case GuiidePlusView.Providers:
        return `${this.guiidePlusPrefix}Prvdr`;
      case GuiidePlusView.Advisers:
        return `${this.guiidePlusPrefix}Advsr`;
      case GuiidePlusView.GuaranteedIncome:
        return `${this.guiidePlusPrefix}GrInc`;
      case GuiidePlusView.StatePensionHelp:
        return `${this.guiidePlusPrefix}StPen`;
      case GuiidePlusView.LumpsSumsAndTax:
        return `${this.guiidePlusPrefix}LpSum`;
      case GuiidePlusView.BenefitsAndCredits:
        return `${this.guiidePlusPrefix}BenCd`;
      case GuiidePlusView.EquityRelease:
        return `${this.guiidePlusPrefix}EqRls`;
      case GuiidePlusView.PartnersIncome:
        return `${this.guiidePlusPrefix}PrtIn`;
    }
  }
}

const guiidePlusMonitoring = new GuiidePlusMonitoring();

export { guiidePlusMonitoring };
